import { IGetLogPageViewAttributes } from './types';

export function getLogPageViewAttributes({
  path,
  store,
  pathname,
  isSmallScreen,
}: IGetLogPageViewAttributes) {
  return {
    path,
    restaurantId: store?.number ?? '',
    restaurantAddress: store?.physicalAddress?.address1 ?? '',
    restaurantZip: store?.physicalAddress?.postalCode ?? '',
    restaurantCity: store?.physicalAddress?.city ?? '',
    restaurantState: store?.physicalAddress?.stateProvince ?? '',
    restaurantCountry: store?.physicalAddress?.country ?? '',
    'Google.Page': '',
    'Google.DocumentReferrer': '',
    pathname,
    sanityId: '',
    referrer: '',
    isSmallScreen: isSmallScreen ? 'True' : 'False',
  };
}
